// extracted by mini-css-extract-plugin
export default {"container":"RegisterPage_container__MXL9S","has-sidebar":"RegisterPage_has-sidebar__Fcg9h","icon":"RegisterPage_icon__cTZzc","aside":"RegisterPage_aside__DoIR2"};